<template>
  <label
    :class="[
      'check',
      { 'check--right-sided': rightSided },
      { 'check--round': round }
    ]"
  >
    {{ label }}
    <input
      type="checkbox"
      :checked="checked"
      @change="changeHandler"
    >
    <span class="check__checkmark" />
  </label>
</template>

<script>
export default {
  name: 'Check',

  props: {
    label: String,
    theData: Object,
    checked: Boolean,
    rightSided: Boolean,
    round: Boolean
  },

  data: () => ({
    isChecked: false
  }),

  created () {
    this.isChecked = this.checked
  },

  updated () {
    this.isChecked = this.checked
  },

  methods: {
    /**
     * Whenever an item is checked send an event to the parent to that an action can be taken.
     */
    changeHandler () {
      this.isChecked = !this.isChecked
      const data = {
        checked: this.isChecked,
        theData: this.theData
      }

      this.$emit('checked-changed', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.check {
  position: relative;
  display: flex;
  align-items: center;
  line-height: $gutter;
  margin: 6px 0;
  padding-left: 32px;
  color: $grey-blue;
  font-size: 12px;
  cursor: pointer;
  user-select: none;

  input {
    @include size(0);

    position: absolute;
    cursor: pointer;
    opacity: 0;

    &:checked ~ .check__checkmark {
      background-color: $blue;
    }
  }
}

.check__checkmark {
  @include size(24px);

  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $grey-blue-light;
  border-radius: $border-radius-default / 2;

  &::after {
    @include size(spacing(3));

    display: none;
    background-image: url('../assets/svg/check.svg');
    background-position: center center;
    background-size: 100%;
    content: '';
  }
}

/* Show the check__checkmark when checked */
.check input:checked ~ .check__checkmark::after {
  display: block;
}

// Right sided
.check--right-sided {
  .check__checkmark {
    @include absolute-center;

    right: 0;
    left: auto;
  }
}

.check--round {
  .check__checkmark {
    background: transparent;
    border: $spacer-unit / 4 solid $grey-light;
    border-radius: 50%;
  }

  input {
    &:checked ~ .check__checkmark {
      border: $spacer-unit / 4 solid $blue;
    }
  }
}
</style>
